import React, { useEffect, useState } from "react";
import "./CardFiveScreen.css";
import indexInvestingImg from "../../assets/index_investing.png";
import girlsAndFinances2025Img from "../../assets/girls_and_finances_2025.png";

export default function CardFiveScreen() {
  const [booksVisible, setBooksVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setBooksVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const element = document.querySelector('.card-five-screen');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="card-five-screen">
      <div className="card-five-content">
        <h1 className="card-five-title">
          Իմ ներդրումը Ձեր կյանքում և ինչու է սա կարևոր ինձ համար։
        </h1>

        <p className="card-five-text">
          Եկեք պայմանավորվենք․ Ես ներդրում եմ անում Ձեր կյանքում, իսկ Դուք վերադարձնում եք՝ կիսվելով ուրիշների հետ։
        </p>

        <p className="card-five-text">
          Սա կարևոր է, որովհետև այս տնտեսությունում հարուստները ավելի են հարստանում, իսկ աղքատները՝ ավելի են աղքատանում։ Եթե Դուք ու ես շարունակենք անվերջ սպառել, մենք կստեղծենք թույլ համայնքներ։ Ես չեմ ուզում, որ իմ երեխաները ապրեն թույլ համայնքներում, Դուք՝ նույնպես։
        </p>

        <div className="book-images">
          <img
            src={indexInvestingImg}
            alt="Index Investing"
            className={`book-image book-left ${booksVisible ? 'pop-in' : ''}`}
          />
          <img
            src={girlsAndFinances2025Img}
            alt="Girls and Finances 2025"
            className={`book-image book-right ${booksVisible ? 'pop-in' : ''}`}
          />
        </div>
      </div>
    </div>
  );
}
